module.exports = __webpack_public_path__ + "media/react/assets/logo-3d90ce3306ffb47ecbafc2ee4a3f6e5d.svg";